{
  "achievement-center": "成就中心",
  "admin": "管理面板",
  "admin-learn": "学习赚币管理",
  "admin-p2p": "P2P管理",
  "admin-referrals": "推荐奖励管理",
  "admin-rewards": "奖励管理",
  "ai-arbitrage-scanner": "AI套利扫描器",
  "ai-assistant": "AI交易助手",
  "ai-copy-trading": "AI跟单交易",
  "ai-grid-trading": "AI网格交易",
  "ai-launchpad": "AI launchpad",
  "ai-market-scanner": "AI市场扫描器",
  "ai-news": "AI资讯",
  "ai-portfolio": "AI资产组合管理",
  "ai-profit-calculator": "AI收益计算器",
  "ai-risk-manager": "AI风险管理",
  "ai-smart-alerts": "AI智能提醒",
  "ai-trust-score": "AI信任评分",
  "ai-whale-alerts": "AI巨鲸预警",
  "ai-whale-heatmap": "AI巨鲸热力图",
  "ai-whale-tracker": "AI巨鲸追踪",
  "buy": "购买加密货币",
  "certificates": "我的证书",
  "dashboard": "仪表盘",
  "exalt-utility-center": "Exalt权益中心",
  "futures": "合约",
  "kyc": "KYC审核请求",
  "kyc-submit": "提交KYC认证",
  "learnearn": "学习赚币",
  "listings": "提交上币申请",
  "markets": "行情",
  "notification-center": "通知中心",
  "orders": "订单",
  "p2p": "币币交易(P2P)",
  "profile": "个人资料",
  "referral": "推荐奖励",
  "reputation-center": "社区信誉",
  "rewards": "奖励",
  "settings": "设置",
  "social-trading": "社交交易",
  "spotTrading": "现货交易",
  "staking": "质押",
  "support": "客服支持",
  "trade": "现货交易",
  "transactions": "交易记录",
  "wallets": "钱包",
  "web3wallet": "Web3钱包"
}